import { SVGProps } from "react";

export default function StepIcon6(props: SVGProps<SVGSVGElement>) {
  return (
<svg {...props} width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.6016 8.23242L9.06603 11.768" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
<path d="M9.44464 5.83271L10.8335 4.44381C12.3677 2.90968 14.855 2.90968 16.3891 4.44381V4.44381C17.9233 5.97794 17.9233 8.46527 16.3891 9.9994L15.0002 11.3883" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
<path d="M12.2233 14.1673L10.8344 15.5562C9.3003 17.0903 6.81298 17.0903 5.27885 15.5562V15.5562C3.74471 14.0221 3.74471 11.5347 5.27885 10.0006L6.66774 8.6117" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
</svg>
 );
};
